export default __webpack_public_path__ + "static/media/auth0-roles-premium.1c4b68e8.png";